import {
  ArrowLeftOutlined,
  CloseCircleOutlined,
  CompassOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import {
  DatePicker,
  Drawer,
  Dropdown,
  Empty,
  Input,
  Menu,
  Modal,
  Select,
  Spin,
  Tooltip,
} from 'antd';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ReactCardFlip from 'react-card-flip';
import { Button, Container } from 'react-floating-action-button';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { BsFillEyeFill } from 'react-icons/bs';
import { TbFileDescription } from 'react-icons/tb';
import Spinner from '../../components/spinner';
import { getData, postData } from '../../config/api-connect';
import './style.css';

const errorModal = (message) => {
  Modal.error({
    title: 'Oops! Something went wrong',
    content: message,
  });
};

export default function SalaryDetails() {
  var today = new Date();
  var mm = JSON.parse(localStorage.getItem('month'));
  var yyyy = today.getFullYear();
  yyyy = yyyy.toString();

  const [cities, setCities] = useState([]);

  const [selectedId, setSelectedId] = useState('');
  const [month, setMonth] = useState(mm);
  const [year, setYear] = useState(yyyy);
  const [data, setData] = useState([]);
  const [isFlipped, setIsFlipped] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [incentive, setIncentive] = useState([]);
  const [open, setOpen] = useState(false);
  // const [show, setShow] = useState(false);
  const [buddyVenue, setBuddyVenue] = useState([]);
  const [editId, setEditId] = useState();
  const [editAmount, setEditAmount] = useState();
  const [editDescription, setEditDescription] = useState();
  const [editAmountStatus, setEditAmountStatus] = useState(false);
  const [editDescriptionStatus, setEditDescriptionStatus] = useState(false);
  const [editedAmount, setEditedAmounted] = useState();
  const [editedDescription, setEditedDescription] = useState();
  const [updatedBy, setUpdatedBy] = useState();
  const [updatedOn, setUpdatedOn] = useState();
  const [downloadData, setDownloadData] = useState([]);
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);
  const [allCity, setAllCity] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [isSalaryModalOpen, setIsSalaryModalOpen] = useState(false);

  const city = JSON.parse(localStorage.getItem('selectedId'));
  const type = JSON.parse(localStorage.getItem('type'));

  const downloadSalaryDetailsofAllCity = useCallback(() => {
    postData('/finance/download_salary_details_all_city/', { month: month, year: year }).then(
      (response) => {
        setAllCity(response.result);
      },
    );
  }, [month, year]);

  const getCitiesVenues = useCallback(async () => {
    setLoading(true);
    await getData('/finance/get_cities_and_venues')
      .then((response) => {
        setCities(response.cities);

        if (city !== 'All' && type === 1) {
          for (var i = 0; i < city.length; i++) {
            if (cities[i]['id'] === city) {
              setSelectedId(city);
            }
          }
          setSelectedId(city);
        } else {
          setSelectedId(response.cities[0].id);
        }
        setLoading(false);
      })
      .catch((error) => {
        errorModal(error.message);
        setLoading(false);
      });
  }, [cities, city, type]);

  useEffect(() => {
    getCitiesVenues();
    downloadSalaryDetailsofAllCity();
  }, [downloadSalaryDetailsofAllCity, getCitiesVenues]);

  useEffect(() => {
    localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    localStorage.setItem('selectedId', JSON.stringify(selectedId));
    localStorage.setItem('type', JSON.stringify('1'));
  }, [month, year, selectedId, type]);

  const getBuddyMonthlyPayments = useCallback(async () => {
    setIsOpen(false);
    setLoading(true);
    await postData('/finance/get_buddy_monthly_payments/', {
      city_id: selectedId,
      year: year,
      month: month,
    })
      .then((response) => {
        setData(response.result);
        setLoading(false);
      })
      .catch((error) => {
        errorModal(error.message);
        setLoading(false);
      });
  }, [selectedId, year, month]);

  useEffect(() => {
    if (selectedId !== '') {
      getBuddyMonthlyPayments();
    }
  }, [selectedId, year, month, getBuddyMonthlyPayments]);

  const getIncentiveRules = useCallback(async () => {
    await getData('/finance/get_incentive_rules')
      .then((response) => {
        setIncentive(response.result);
      })
      .catch((error) => {
        errorModal(error.message);
      });
  }, []);

  useEffect(() => {
    if (open) {
      getIncentiveRules();
    }
  }, [getIncentiveRules, open]);

  const successModal = (message) => {
    Modal.success({
      title: message,
    });
  };
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <span onClick={() => salaryEdit()}>Edit</span>
      </Menu.Item>
    </Menu>
  );

  const [isModalOpen, setIsModalOpen] = useState(false);

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsOpen(false);
    setIsSalaryModalOpen(false);
    setEditAmount();
    setEditAmountStatus(false);
    setEditDescription();
    setEditDescriptionStatus(false);
    setIsDownloadOpen(false);
  };
  const getid = (id) => {
    setEditId(id);
  };

  const salaryEdit = () => {
    setIsOpen(true);
  };
  const edit_amount = (e) => {
    setEditAmount(e.target.value);
    setEditAmountStatus(false);
  };
  const edit_description = (e) => {
    setEditDescription(e.target.value);
    setEditDescriptionStatus(false);
  };

  const editSave = () => {
    if (editAmount === '' || editAmount === undefined) {
      setEditAmountStatus(true);
    } else if (editDescription === '' || editDescription === undefined) {
      setEditDescriptionStatus(true);
    } else {
      postData('/finance/salary_edit/', {
        id: editId,
        amount: editAmount,
        description: editDescription,
      })
        .then((response) => {
          successModal(response.result);
          setLoading(true);
          setEditAmount();
          setEditAmountStatus(false);
          setEditDescription();
          setEditDescriptionStatus(false);
        })
        .catch((error) => {
          alert(error.message);
        });
      getBuddyMonthlyPayments();
      // setIsOpen(false)
    }
  };
  const salary_edit_detail = (item) => {
    setEditedAmounted(item.others);
    setEditedDescription(item.description);
    setUpdatedBy(item.updatedby);
    setUpdatedOn(item.updated_on);
    setIsSalaryModalOpen(true);
  };

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };

  const getVenue = (item) => {
    setIsModalOpen(true);
    setBuddyVenue(item);
  };

  const downloadDetails = () => {
    setIsDownloadOpen(true);
    downloadSalaryDetails(selectedId);
  };

  const downloadSalaryDetails = (id) => {
    postData('/finance/download_salary_details/', { id: id, month: month, year: year }).then(
      (response) => {
        setDownloadData(response.result);
      },
    );
  };

  // const cancel = (id) => {
  //   message.error(id);
  // };

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <div className="salary-main-container">
        <Drawer
          title="Incentive Rules"
          placement="right"
          onClose={onClose}
          visible={open}
          closeIcon={<CloseCircleOutlined className="salary-drawer-close-icon" />}
          className="salary-drawer-incentives"
        >
          <div>
            {incentive.map((item, i) => (
              <div key={i}>
                {item.key.includes('bangalore') ? (
                  <div className="salary-incentive-section"> Bangalore </div>
                ) : item.key.includes('cm') ? (
                  <div className="salary-incentive-section-space"> Kerala - CM + Coach </div>
                ) : (
                  <div className="salary-incentive-section-space"> Kerala - Coach </div>
                )}

                {item.rules.terms.map((term, index) => (
                  <div key={index}>
                    From {term.from} to {term.to} : {term.amount} per kid
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Drawer>

        <div className="salary-top-header">
          <div className="salary-selector">
            <Select
              className="salary-select-width"
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.name.toLowerCase().includes(input.toLowerCase())
              }
              onChange={setSelectedId}
              value={selectedId}
              bordered={false}
            >
              {cities.map((item) => (
                <Select.Option value={item.id} key={item.id} name={item.name}>
                  {' '}
                  {item.name}{' '}
                </Select.Option>
              ))}
            </Select>
          </div>

          <div className="salary-flex">
            <div className="salary-selector salary-select-margin">
              <Select
                className="salary-select-auto"
                onChange={setMonth}
                value={month}
                bordered={false}
              >
                <Select.Option value="12"> December </Select.Option>
                <Select.Option value="11"> November </Select.Option>
                <Select.Option value="10"> October </Select.Option>
                <Select.Option value="09"> September </Select.Option>
                <Select.Option value="08"> August </Select.Option>
                <Select.Option value="07"> July </Select.Option>
                <Select.Option value="06"> June </Select.Option>
                <Select.Option value="05"> May </Select.Option>
                <Select.Option value="04"> April </Select.Option>
                <Select.Option value="03"> March </Select.Option>
                <Select.Option value="02"> February </Select.Option>
                <Select.Option value="01"> January </Select.Option>
              </Select>
            </div>

            <div className="salary-selector">
              <DatePicker
                defaultValue={moment(year, 'YYYY')}
                onChange={onChangeYear}
                bordered={false}
                picker="year"
              />
            </div>
          </div>
        </div>

        <div className="salary-download-bottom">
          <div className="salary-download-bottom-button" onClick={downloadDetails}>
            Download Details
          </div>
        </div>

        <div className="salary-body-container">
          {data.length > 0 ? (
            data.map((item, index) => (
              <ReactCardFlip isFlipped={isFlipped === index ? true : false}>
                <div className="salary-buddy-card" key={index}>
                  <div className="salary-card-actions">
                    <Dropdown overlay={menu} trigger={['click']}>
                      <MoreOutlined
                        onClick={() => {
                          getid(item.id);
                        }}
                      />
                    </Dropdown>
                  </div>
                  <div className="salary-card-center">
                    <img
                      src={item.buddy_photo}
                      className="salary-buddy-img"
                      alt={item.buddy_name}
                    />
                    <div className="salary-buddy-name"> {item.buddy_name} </div>
                    <div className="salary-buddy-type"> {item.buddy_type} </div>
                  </div>

                  <div className="salary-mt-10">
                    <div className="salary-venue-badge">
                      {item.venues &&
                        item.venues.map(
                          (venue, index) =>
                            index < 2 && (
                              <div>
                                {venue.name.length > 20 ? (
                                  <span>{venue.name.substring(0, 22)}...</span>
                                ) : (
                                  <span>{venue.name}</span>
                                )}
                              </div>
                            ),
                        )}
                      {item.venues.length > 3 && (
                        <Tooltip title="View More">
                          <BsFillEyeFill
                            size={'1em'}
                            className="salary-cursor-pointer"
                            onClick={() => getVenue(item.venues)}
                          />
                        </Tooltip>
                      )}
                    </div>

                    <div className="salary-mt-15">
                      <div className="salary-grid-row">
                        <span>Basic Pay </span>
                        <span> : </span>
                        <span> {item.basic_pay} </span>
                      </div>
                      <div className="salary-grid-row">
                        <span>Incentives </span>
                        <span> : </span>
                        <span> {item.incentive} </span>
                      </div>
                      <div className="salary-grid-row">
                        <span>Reimbursement </span>
                        <span> : </span>
                        <span> {item.reimbursement} </span>
                      </div>
                      <div className="salary-grid-row">
                        <span>Others </span>
                        <span> : </span>
                        <span>
                          {' '}
                          {item.others}
                          {item.description && (
                            <Tooltip title="Description">
                              <TbFileDescription
                                onClick={() => salary_edit_detail(item)}
                                className="salary-cursor-pointer"
                              />
                            </Tooltip>
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="salary-total-row">
                      <span>Total </span>
                      <span> : </span>
                      <span>
                        {' '}
                        {item.basic_pay + item.incentive + item.reimbursement + item.others}{' '}
                      </span>
                    </div>
                  </div>

                  <div className="salary-view-details-bar" onClick={() => setIsFlipped(index)}>
                    <div className="salary-view-details-btn">View Details</div>
                  </div>
                </div>

                <div className="salary-buddy-card">
                  <div className="salary-fce-header">
                    <ArrowLeftOutlined
                      onClick={() => setIsFlipped(-1)}
                      className="salary-fce-header-icon"
                    />
                    <div className="salary-fce-header-title"> FCE Data </div>
                    <span></span>
                  </div>

                  <div className="salary-mt-10">
                    {item.fce.map((data) => (
                      <div>
                        <div className="salary-fce-venue"> {data.venue} </div>
                        {data.data.map((i) => (
                          <div className="salary-fce-data-row">
                            <span> {i.program} </span>
                            <span> : </span>
                            <span> {i.fce_count} </span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </ReactCardFlip>
            ))
          ) : (
            <div className="salary-empty-state">
              <Empty
                description={<span className="salary-empty-text"> data not available </span>}
              />
            </div>
          )}
        </div>
      </div>

      <Container>
        <Button
          tooltip="View incentive rules"
          rotate={true}
          onClick={showDrawer}
          styles={{
            backgroundColor: '#052e67',
            position: 'fixed',
            bottom: 20,
            right: 20,
            height: '45px',
            width: '45px',
          }}
        >
          <CompassOutlined className="salary-fab-icon" />
        </Button>
      </Container>

      <Modal
        title="Venue Details "
        visible={isModalOpen}
        onCancel={handleCancel}
        okButtonProps={{ className: 'salary-hidden' }}
      >
        {buddyVenue.map((items) => {
          return <div className="venue">{items.name}</div>;
        })}
      </Modal>
      <Modal
        title="Edit Salary  Details "
        visible={isOpen}
        onCancel={handleCancel}
        onOk={() => editSave()}
      >
        <Row>
          <Col>
            <span>Amount </span>
          </Col>
          <Col>
            <Input
              type="number"
              value={editAmount}
              onChange={edit_amount}
              className="salary-input-width"
            />
            {editAmountStatus && <p className="salary-error-text">Please fill the amount</p>}
          </Col>
          <Col></Col>
        </Row>
        <Row className="salary-mt-7">
          <Col>
            <span>Description </span>
          </Col>

          <Col>
            <Input.TextArea
              type="text"
              value={editDescription}
              onChange={edit_description}
              className="salary-input-width"
            />
            {editDescriptionStatus && <p className="salary-error-text">Cannot be Blank</p>}
          </Col>
          <Col></Col>
        </Row>
      </Modal>
      <Modal
        title="Edited Details "
        visible={isSalaryModalOpen}
        onCancel={handleCancel}
        okButtonProps={{ className: 'salary-hidden' }}
      >
        <Row>
          <Col>
            <span>Amount </span>
          </Col>
          <Col>
            <span>{editedAmount}</span>
          </Col>
        </Row>
        <Row className="salary-mt-7">
          <Col>
            <span>Description </span>
          </Col>
          <Col>
            <span>{editedDescription}</span>
          </Col>
        </Row>
        <Row className="salary-mt-7">
          <Col>Edited By </Col>
          <Col>{updatedBy}</Col>
        </Row>
        <Row className="salary-mt-7">
          <Col>Edited On </Col>
          <Col>{updatedOn}</Col>
        </Row>
      </Modal>
      <div>
        <Modal
          title="Download Salary Data"
          visible={isDownloadOpen}
          onCancel={handleCancel}
          okButtonProps={{ className: 'salary-hidden' }}
        >
          <span>Choose an Option</span>
          <div>
            <ReactHTMLTableToExcel
              id="btn btn-lg"
              className="collection-xls-button downloadtable"
              table="table-to-download"
              filename="Salary Details"
              sheet="Salary Details"
              buttonText="Salary Details of Current City"
            />
            <ReactHTMLTableToExcel
              id="btn btn-lg"
              className="collection-xls-button downloadtable"
              table="table-to-download-all-city"
              filename="Salary Details of All City"
              sheet="Salary Details"
              buttonText="Salary Details of All City"
            />
          </div>
        </Modal>
      </div>
      <table className="salary-hidden" id="table-to-download">
        <thead>
          <tr>
            <th>Name</th>
            <th>Designation</th>
            <th>Center</th>
            <th>Account No.</th>
            <th>IFSC Code</th>
            <th>Fce Count</th>
            <th>Basic Salary</th>
            <th>Incentive</th>
            <th>Reimbursment</th>
            <th>Others</th>
            <th>Total</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {downloadData.map((item) => (
            <tr>
              <td>{item.buddy_name}</td>
              <td>{item.buddy_type}</td>
              <td>
                {item.fce.venue.map((items) => (
                  <div>{items.venue}</div>
                ))}
              </td>
              <td>{item.account_details.account_no}</td>
              <td>{item.account_details.ifsc}</td>
              <td>{item.fce.fce_count}</td>
              <td>{item.basic_pay}</td>
              <td>{item.incentive}</td>
              <td>{item.reimbursement}</td>
              <td>{item.others}</td>
              <td>{item.basic_pay + item.incentive + item.reimbursement + item.others}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <table className="salary-hidden" id="table-to-download-all-city">
        <thead>
          <tr>
            <th>Name</th>
            <th>Designation</th>
            <th>Center</th>
            <th>Account No.</th>
            <th>IFSC Code</th>
            <th>Fce Count</th>
            <th>Basic Salary</th>
            <th>Incentive</th>
            <th>Reimbursment</th>
            <th>Others</th>
            <th>Total</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {allCity.map((item) => (
            <tr>
              <td>{item.buddy_name}</td>
              <td>{item.buddy_type}</td>
              <td>
                {item.fce.venue.map((items) => (
                  <div>{items.venue}</div>
                ))}
              </td>
              <td>{item.account_details.account_no}</td>
              <td>{item.account_details.ifsc}</td>
              <td>{item.fce.fce_count}</td>
              <td>{item.basic_pay}</td>
              <td>{item.incentive}</td>
              <td>{item.reimbursement}</td>
              <td>{item.others}</td>
              <td>{item.basic_pay + item.incentive + item.reimbursement + item.others}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Spin>
  );
}
